import { mergeAttributes, Node, ReactNodeViewRenderer } from '@tiptap/react'
import Component from './component'

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		block: {
			setBlock: () => ReturnType
			setBlockAlign: (align: string) => ReturnType
		}
	}
}

export const Block = Node.create({
	name: 'topblock',

	isolating: true,

	content: 'block',

	defining: true,

	group: 'block',

	draggable: true,

	selectable: true,

	addAttributes() {
		return {
			align: {
				default: 'left',
			},
		}
	},

	parseHTML() {
		return [{ tag: this.name }]
	},

	renderHTML({ HTMLAttributes, node }) {
		const align = node.attrs.align || 'left'

		return [
			this.name,
			mergeAttributes(HTMLAttributes, {
				align: align,
				'data-type': 'topblock',
				style: `text-align: ${align};`,
			}),
			0,
		]
	},

	addCommands() {
		return {
			setBlock:
				() =>
				({ commands }) =>
					commands.insertContent({
						type: 'topblock',
						attrs: {
							align: 'left',
						},
						content: [{ type: 'text', text: 'Hello' }],
					}),
			setBlockAlign:
				align =>
				({ commands }) =>
					commands.updateAttributes('topblock', { align }),
		}
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})

export default Block
